"use client";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import map from "../../../Assets/maps.png";
import cargoShip from "../../../Assets/cargo-ship.png";
import shore from "../../../Assets/shore.png";
import shoreMobile from "../../../Assets/shore-mobile.png"; // Import the mobile shore image
import "./ShipShore.scss";

function ShipShore() {
  return (
    <Container fluid className="ship-shore-section">
      <Container className="ship-shore-container">
        <Row className="align-items-center">
          {/* Text Section */}
          <Col md={5} className="ship-text-container justify-center">
            <h1>We Source. <div>We Manufacture.</div> We <span className="extra">Deliver.</span></h1>
            <p>
            Connecting you with the best manufacturing solutions from Asia. Partner with us for streamlined sourcing and efficient delivery.
            </p>
            <div className="button-group">
              <a href="/about" className="primary-button">ABOUT US</a>
              <a href="/contact" className="secondary-button">CONTACT</a>
            </div>
          </Col>

          {/* Map and Ship Section */}
          <Col md={7} className="map-container">
            <div className="map-wrapper">
              <img src={map} alt="World Map" className="map-image" />
              <img
                src={shore}
                alt="Shore"
                className="shore-image desktop-shore"
              />
              <img
                src={shoreMobile}
                alt="Shore Mobile"
                className="shore-image mobile-shore"
              />
              {map && (
                <div className="dots-container">
                  {/* Dots on specific map regions */}
                  {[...Array(20)].map((_, i) => (
                    <div className="dot" key={i}></div>
                  ))}
                </div>
              )}
              <div className="ship-container">
                <img src={cargoShip} alt="Cargo Ship" className="ship-image" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default ShipShore;
